<template lang="html">
  <v-row class="flex-nowrap mt-2 mb-0" :justify="justifyClass" v-bind="$attrs">
    <v-col v-if="!noCancel" cols="auto">
      <slot name="button-cancel">
        <v-btn
          color="primary"
          class="px-4 py-2"
          text
          outlined
          v-bind="cancelAttrs"
          @click="$emit('cancel')"
        >
          <slot name="button-cancel-inner">
            <v-icon left>
              mdi-close
            </v-icon>
            {{ cancelText || $t('buttons.cancel') }}
          </slot>
        </v-btn>
      </slot>
    </v-col>
    <v-col v-if="!noContinue" cols="auto">
      <slot name="button-continue">
        <v-btn
          color="primary"
          class="px-4 py-2 ml-2"
          v-bind="continueAttrs"
          @click="$emit('continue')"
          :disabled="disabled"
        >
          <slot name="button-continue-inner">
            {{ continueText || $t('buttons.continue') }}
            <v-icon right>
              mdi-check
            </v-icon>
          </slot>
        </v-btn>
      </slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    cancelAttrs: {
      type: Object,
      default: () => {},
    },
    continueAttrs: {
      type: Object,
      default: () => {},
    },
    noCancel: {
      type: Boolean,
      default: false,
    },
    noContinue: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: '',
    },
    continueText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    justifyClass() {
      if (!this.noCancel && !this.noContinue) return 'space-between';
      if (!this.noCancel && this.noContinue) return 'start';

      return 'end';
    },
  },
};
</script>

<style lang="css" scoped></style>
